import { MetadataOptions, DatatypeSelectorProps } from './types';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import React from 'react';
import moment from 'moment';
import FormFileUploadSimple from '../DataTypeComponents/FileUpload';

function DatatypeInput(props: DatatypeSelectorProps) {
  const { inputType, onSelect, label, value, width, disabled = false } = props;
  const [inputValue, setInputValue] = React.useState<any>(value);


  const handleDateChange = (newValue: any) => {
    setInputValue(moment(newValue?._d || null));
    onSelect && onSelect(moment(newValue?._d || null).format('YYYY-MM-DD'));

  };

  const handleTextChange = (e: any) => {
    setInputValue(e.target.value);
    onSelect && onSelect(e.target.value);

  };

  const handleCheckboxChange = (e: any, array: any, key: string | number) => {
    const newArray = array.map((entry: any) => {
      if (entry.key === key) {
        entry.value = e.target.checked;
      }
      return entry;
    });

    setInputValue(newArray);
    onSelect && onSelect(newArray);

  };

  const handleFileChange = (fileArray: any) => {
    setInputValue(fileArray);
    onSelect && onSelect(fileArray);

  };

  const onRadioChange = (e: any, array: any, key: string | number) => {
    const newArray = array.map((entry: any) => {
      if (entry.key === key) {
        entry.value = e.target.checked;
      }
      return entry;
    });

    setInputValue(newArray);
    onSelect && onSelect(newArray);
  };

  React.useEffect(() => {
    setInputValue(value);
  }, [value]);
  switch (inputType) {
  case MetadataOptions.Date:
    return <LocalizationProvider dateAdapter={AdapterMoment} >
      <DesktopDatePicker
        disabled={disabled}
        label={label}
        PopperProps={{
          disablePortal: true
        }}
        inputFormat='DD/MM/YYYY'
        value={inputValue}
        onChange={handleDateChange}
        renderInput={(params) => <TextField fullWidth
          {...params} style={{ minWidth: width }} 
          sx={{
            '& .MuiOutlinedInput-root': {
              fieldset: {
                borderColor: '#000 !important' 
              }
            },
            '& .MuiInputLabel-root': {
              color: '#000 !important' 
            },
            '& .MuiInputBase-input': {
              color: '#000'
            }
          }}/>}
      />
    </LocalizationProvider>;
  case MetadataOptions.String:
    return <TextField
      fullWidth
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
      style={{ minWidth: width }}
      value={inputValue}
      label={label}
      onChange={handleTextChange}
      sx={{
        '& .MuiOutlinedInput-root': {
          fieldset: {
            borderColor: '#000 !important' 
          }
        },
        '& .MuiInputLabel-root': {
          color: '#000 !important' 
        },
        '& .MuiInputBase-input': {
          color: '#000'
        }
      }}
      
    />;

  case MetadataOptions.Number:
    return <TextField
      fullWidth
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
      type='number'
      style={{ minWidth: width }}
      value={inputValue}
      label={label}
      onChange={handleTextChange}
      sx={{
        '& .MuiOutlinedInput-root': {
          fieldset: {
            borderColor: '#000 !important' 
          }
        },
        '& .MuiInputLabel-root': {
          color: '#000 !important' 
        },
        '& .MuiInputBase-input': {
          color: '#000'
        }
      }}
    />;

  case MetadataOptions.Text:
    return <TextField
      fullWidth
      disabled={disabled}
      InputLabelProps={{ shrink: true }}
      multiline
      rows={5}
      style={{ minWidth: width }}
      value={inputValue}
      label={label}
      onChange={handleTextChange}
      sx={{
        '& .MuiOutlinedInput-root': {
          fieldset: {
            borderColor: '#000 !important' 
          }
        },
        '& .MuiInputLabel-root': {
          color: '#000 !important' 
        },
        '& .MuiInputBase-input': {
          color: '#000'
        }
      }}
    />;

  case MetadataOptions.Checkbox:
    return <FormControl fullWidth sx={{ m: 3}}
      component='fieldset'
      variant='standard'>
      <FormLabel component='legend' sx={{ color: '#000 !important'}}>{label}</FormLabel>
      <FormGroup sx={{ "& .MuiFormControlLabel-label": {
        fontSize: '1.5rem',
        color: '#000'
      }}}>
        {Array.isArray(inputValue) && inputValue.map((entry: any) => <FormControlLabel
          key={entry.key}
          control={
            <Checkbox
              
              disabled={disabled}
              onChange={(e) =>
                handleCheckboxChange(e, inputValue, entry.key)}
              checked={entry.value || false}
              name={entry.label}
            />
          }
          label={entry.label}
        />)}
      </FormGroup>
    </FormControl>;

  case MetadataOptions.File:
    return <FormFileUploadSimple
      disabled={disabled}
      label={label}
      value={inputValue}
      onFileSelect={(files: any) => handleFileChange(files)}
    />;

  case MetadataOptions.Radio:
    return <FormControl fullWidth>
      <FormLabel id='demo-radio-buttons-group-label' 
        sx={{ color: '#000 !important',
          '&.Mui-focused': { 
            color: '#000' 
          } 
        }}>{label}</FormLabel>
      <RadioGroup>
        {
          Array.isArray(inputValue) && inputValue.map((item) => {
            return (
              <FormControlLabel
                disabled={disabled}
                onChange={(e) => onRadioChange(e, inputValue, item.key)}
                key={item.key}
                value={item.label}
                control={<Radio />}
                label={item.label} />
            );
          })
        }
      </RadioGroup>
    </FormControl>;

  default:
    return <></>;
  }
}

export default DatatypeInput;